import type { SubscriptionCountOptions, SubscriptionCreateDto, SubscriptionDto, SubscriptionFullDto, SubscriptionIncludeOptions, SubscriptionQueryOptions, SubscriptionUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultWithStatsDto } from '../common/models';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  apiName = 'Default';

  create = (input: SubscriptionCreateDto, cancellationToken?: any) =>
    this.restService.request<any, SubscriptionDto>({
      method: 'POST',
      url: `/api/app/subscription`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string, cancellationToken?: any) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/subscription/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string, options: SubscriptionIncludeOptions, cancellationToken?: any) =>
    this.restService.request<any, SubscriptionDto>({
      method: 'GET',
      url: `/api/app/subscription/${id}`,
      params: { currUserIdOverride: options?.currUserIdOverride, includePreset: options?.includePreset, includeProduct: options?.includeProduct, includeOffers: options?.includeOffers, includeOffersByStore: options?.includeOffersByStore, includeCurrUserReceipt: options?.includeCurrUserReceipt },
    },
    { apiName: this.apiName });

  getCount = (options?: SubscriptionCountOptions, cancellationToken?: any) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: `/api/app/subscriptions/count`,
      params: { searchUser: options?.searchUser, currUserIdOverride: options?.currUserIdOverride, filterSubscriptionType: options?.filterSubscriptionType, filterQualityAccessLevel: options?.filterQualityAccessLevel, filterProductType: options?.filterProductType, filterOfferId: options?.filterOfferId, filterCurrUserPurchased: options?.filterCurrUserPurchased, searchText: options?.searchText },
    },
    { apiName: this.apiName });

  getList = (options?: SubscriptionQueryOptions, cancellationToken?: any) =>
    this.restService.request<any, PagedResultDto<SubscriptionFullDto>>({
      method: 'GET',
      url: `/api/app/subscriptions`,
      params: { searchText: options?.searchText, searchUser: options?.searchUser, currUserIdOverride: options?.currUserIdOverride, filterSubscriptionType: options?.filterSubscriptionType, filterQualityAccessLevel: options?.filterQualityAccessLevel, filterProductType: options?.filterProductType, filterOfferId: options?.filterOfferId, filterCurrUserPurchased: options?.filterCurrUserPurchased, includePreset: options?.includePreset, includeProduct: options?.includeProduct, includeOffers: options?.includeOffers, includeOffersByStore: options?.includeOffersByStore, includeCurrUserReceipt: options?.includeCurrUserReceipt, maxResultCount: options?.maxResultCount, sorting: options?.sorting, skipCount: options?.skipCount },
    },
    { apiName: this.apiName });

  getListWithStats = (options: SubscriptionQueryOptions, cancellationToken?: any) =>
    this.restService.request<any, PagedResultWithStatsDto<SubscriptionFullDto>>({
      method: 'GET',
      url: `/api/app/subscriptions/with-stats`,
      params: { searchText: options?.searchText, searchUser: options?.searchUser, currUserIdOverride: options?.currUserIdOverride, filterSubscriptionType: options?.filterSubscriptionType, filterQualityAccessLevel: options?.filterQualityAccessLevel, filterProductType: options?.filterProductType, filterOfferId: options?.filterOfferId, filterCurrUserPurchased: options?.filterCurrUserPurchased, includePreset: options?.includePreset, includeProduct: options?.includeProduct, includeOffers: options?.includeOffers, includeOffersByStore: options?.includeOffersByStore, includeCurrUserReceipt: options?.includeCurrUserReceipt, maxResultCount: options?.maxResultCount, sorting: options?.sorting, skipCount: options?.skipCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: SubscriptionUpdateDto, cancellationToken?: any) =>
    this.restService.request<any, SubscriptionDto>({
      method: 'PUT',
      url: `/api/app/subscription/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
